import { render, staticRenderFns } from "./ThermodynamicsFirstLawViz.vue?vue&type=template&id=4264ab33&scoped=true"
import script from "./ThermodynamicsFirstLawViz.vue?vue&type=script&lang=js"
export * from "./ThermodynamicsFirstLawViz.vue?vue&type=script&lang=js"
import style0 from "./ThermodynamicsFirstLawViz.vue?vue&type=style&index=0&id=4264ab33&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4264ab33",
  null
  
)

export default component.exports